import { defineStore } from 'pinia';
import axios from 'axios'

export const useStore = defineStore('Main', {
	state: () => ({
		user: {
            PK: '',
            SK: '',
            siteName: '',
            userName: '',
            userAccount: '',
            userRole: '',
            accountValidDate: '',
		},
        systemName: window.VUE_APP_System, //recommend //behavior
        isDev: window.VUE_APP_Dev,
        lineLoginChannelID: '2002453323', // Replace this with your Line Login Channel ID
        myLiffId: '2002453323-20Lo31Kp',
        userLoginType: 'line',
	}),

	getters: {},

	actions: {
        getUser() {
            const self = this;
            let linecode = localStorage.getItem("linecode");

            // 呼叫API獲取資料
            axios.get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/getUser', {
                params: {
                    survey_type: self.systemName,
                    userId: linecode, // 這裡設置您的條件
                },
            })
                .then(response => {
                    if (response.data) {
                        localStorage.setItem("userRole", response.data.userRole);
                        self.user.PK = response.data.PK;
                        self.user.SK = response.data.SK;
                        self.user.siteName = response.data.siteName;
                        self.user.userAccount = response.data.userAccount;
                        self.user.userName = response.data.userName;
                        self.user.userRole = response.data.userRole;
                        self.user.accountValidDate = response.data.accountValidDate;
                    } else {
                        self.$router.push({ path: "/register" });
                    }
                })
                .catch(error => {
                    console.error('無法獲取資料：', error)
                })
        },

		// setLoading(q) {
		// 	this.isLoading = q;
		// },

		// setStatus() {
		// 	this.isStatusChecked = true;
		// },

		// setUser(q) {
		// 	this.user.id = q.id;
		// 	this.user.email = q.email;
		// 	this.user.name = q.name;
		// 	this.user.userName = q.userName;

		// },
		

		logout() {
            localStorage.removeItem('userLoginType');
            localStorage.removeItem('linecode');
            localStorage.removeItem('idToken');
            localStorage.removeItem('googlecode');
            localStorage.removeItem('LIFF_STORE:2002453331-wK4xYK9O:loginTmp');
            localStorage.removeItem('LIFF_STORE:2002453323-20Lo31Kp:loginTmp');
            localStorage.removeItem('LIFF_STORE:2002453323-20Lo31Kp:context');
            localStorage.removeItem('LIFF_STORE:2002453331-wK4xYK9O:context');
		},
	},
});
